<template>
  <AppLink
    hide_underline
    :class="class_navbar_item"
    :data-test="expose_data_test ? item.data_test : null"
    :to="navigate_to"
  >
    <slot>
      <span>{{ t(item.title) }}</span>
    </slot>
  </AppLink>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const BASE = 'flex shrink-0 items-center self-stretch border-b-2 no-underline transition-colors duration-150';
const ACTIVE = 'border-primary-400 font-semibold text-neutral-900';
const INACTIVE = 'border-transparent font-normal text-neutral-600 hover:border-neutral-300 hover:text-neutral-900';

const props = defineProps({
  item: { type: Object, required: true },
  params: { type: Object, default: null },
  expose_data_test: { type: Boolean, default: true },
});

const { t } = useI18n();
const route = useRoute();

const is_active = computed(() => !!props.item.prefix && route.name.startsWith(props.item.prefix));

const class_navbar_item = computed(() => `${BASE} ${is_active.value ? ACTIVE : INACTIVE}`);

const navigate_to = computed(() => ({ name: props.item.name, params: props.params }));
</script>
